import type { ExtratoSolicitacaoItem } from "../../../../services/ExtractService";
import type { ExtractRow } from "../shared/extractListTypes";
import {
  normalizeExtratoListItemDates,
  onlyDigits,
  pickSituacaoIdApi,
  resolveSituacaoExtratoParaLista,
} from "../shared/extractListUtils";

const resolveSolicitacaoId = (item: ExtratoSolicitacaoItem): number | null =>
  item?.idSolicitacaoAvaliacao ??
  item?.solicitacaoId ??
  item?.idQuestionarioResposta ??
  null;

export const mapSolicitacoesToSindicatoRows = (
  solicitacoes: ExtratoSolicitacaoItem[],
  ano: number,
  sindicatoCnpj?: string | null,
): ExtractRow[] => {
  const cnpjFiltro = onlyDigits(sindicatoCnpj);

  return (solicitacoes || [])
    .filter((item) => {
      if (!cnpjFiltro) return true;
      return onlyDigits(item?.cnpj) === cnpjFiltro;
    })
    .map((item) => {
      const datas = normalizeExtratoListItemDates(item);
      const solicitacaoId = resolveSolicitacaoId(item);

      return {
        id: solicitacaoId ?? 0,
        cnpj: item?.cnpj ?? null,
        sigla: item?.sigla ?? null,
        solicitacao: item?.solicitacao || "—",
        situacao: resolveSituacaoExtratoParaLista(item),
        situacaoId: pickSituacaoIdApi(item),
        envio: datas.envio,
        atualizacao: datas.atualizacao,
        questionario: solicitacaoId,
        idSindicato: item?.idSindicato ?? null,
        solicitacaoId,
        ano,
        historicoHabilitado: !!solicitacaoId && solicitacaoId !== 0,
        rowKey: `sindicato-${solicitacaoId ?? "x"}-${ano}`,
      };
    })
    .sort(
      (a, b) => Number(a.solicitacaoId ?? 0) - Number(b.solicitacaoId ?? 0),
    );
};
